import React, { FC } from 'react'
import { Redirect, RouteProps, Route } from 'react-router-dom'
import { auth } from 'Helpers'
import { FrontUrls, NOT_FOR_REDIRECT_URLS } from 'Src/constants/FrontUrls'
import { authSlice } from 'Pages/auth'
import { LocalStorage } from 'Modules'
import { useAppDispatch } from 'Src/hooks'

export const PrivateRoute: FC<RouteProps> = (props: RouteProps) => {
	const { location } = props
	const { logout } = useAppDispatch({
		logout: authSlice.actions.logout,
	})
	if (auth.loggedIn()) {
		return <Route {...props} />
	}
	if (!NOT_FOR_REDIRECT_URLS.has(location.pathname)) {
		LocalStorage.setUserSettings({ redirect: location.pathname + location.search })
	}
	logout()
	return <Redirect to={FrontUrls.auth.index} />
}
